import React from "react";

export default function BlurredBackdropModal({ show, onClose, children }) {

  if (!show) {
    return null;
  }

  return (
    <>
      {/* BLUR LAYER */}
      <div
        onClick={onClose}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backdropFilter: "blur(6px)",
          backgroundColor: "rgba(0,0,0,0.25)",
          zIndex: 999
        }}
      />

      {/* MODAL CONTENT */}
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 1000
        }}
      >
        {children}
      </div>
    </>
  );
}
